<div class="manage-presenters-container">
  <!-- Cross-room toggle -->
  @if (isConnectedRoom()) {
    <div class="cross-room-toggle-wrapper flex justify-center items-center m-b-8">
      <span class="m-r-8 flex-1 alignt-center">Current Room</span>
      <mat-slide-toggle
        [checked]="isCrossRoom()"
        (change)="onCrossRoomToggle()"
        [disabled]="isSomeoneElsePresenting()"
      ></mat-slide-toggle>
      <span class="m-l-8 flex-1 alignt-center"> All Rooms </span>
    </div>
  }

  <!-- Add buttons -->
  <div
    class="add-presenter-wrapper"
    [matTooltip]="isPresentationFull() ? 'You can only have up to 4 active Presenters or Livestreams' : ''"
  >
    <button
      matRipple
      class="w-full button uppercase weight-bold flex justify-between items-center"
      (click)="addPresenter()"
      [disabled]="isPresentationFull()"
    >
      <span>Add Presenter</span>
      <mat-icon svgIcon="CIRCLE_PLUS"></mat-icon>
    </button>

    @if (isLiveStreamEnabled()) {
      <button
        matRipple
        class="w-full m-t-8 button uppercase weight-bold flex justify-between items-center"
        (click)="addLivestream()"
        [disabled]="isPresentationFull()"
      >
        <span>Add Livestream</span>
        <mat-icon svgIcon="CIRCLE_PLUS"></mat-icon>
      </button>
    }
  </div>

  <!-- Presenting section -->
  <div class="presenting-section p-8 m-t-8 flex flex-column" style="max-height: 100%">
    <div class="flex justify-start items-center m-b-12 flex-1">
      <span class="m-r-10 presenting-icon bg-color-warning-red"></span>
      <span class="uppercase weight-bold">Presenting</span>
    </div>
    <div class="presenters-wrapper flex flex-column">
      @for (presenter of presenters() | keyvalue; track presenter.key) {
        <div class="presenter-container m-b-8">
          <div class="flex justify-between items-center m-b-12 flex-1">
            <span class="text-overflow-ellipsis flex-1">{{ getPresenterName(presenter.value) }}</span>
            <button
              type="button"
              mat-mini-fab
              matRipple
              color="warn"
              aria-label="remove presenter"
              class="remove-btn flex items-center justify-center m-l-8 material-icons"
              (click)="removePresenter(presenter.value)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
          @if (presenter.value.presenterType === 'LIVE_STREAM') {
            <div class="flex justify-between items-center m-b-12 flex-1">
              <mat-slide-toggle
                data-testid="queue-broadcast-toggle"
                (toggleChange)="queueBroadcast(presenter.value)"
                [checked]="isLivestreamBroadcasting(presenter.key)"
              >
                Broadcasting
              </mat-slide-toggle>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Not Presenting Section -->

  <div class="presenting-section p-8 m-t-8 flex flex-column" style="max-height: 100%">
    <div class="flex justify-start items-center m-b-12 flex-1">
      <span class="m-r-10 presenting-icon bg-color-grey-400"></span>
      <span class="uppercase weight-bold">Not Presenting</span>
    </div>
    <div class="not-presenting-container flex flex-column">
      <!-- Presenters -->
      @for (invitedPresenter of invitedPresenters() | keyvalue; track invitedPresenter) {
        <app-chip
          [text]="getPresenterName(invitedPresenter.value)"
          [wFull]="true"
          (accessoryRightClick)="removeInvitedPresenter(invitedPresenter.key)"
        >
          <div accessory-left>
            <mat-icon class="mat-icon-airplane" svgIcon="AIRPLANE"></mat-icon>
          </div>
          <div accessory-right>
            <button
              type="button"
              mat-mini-fab
              matRipple
              color="warn"
              aria-label="remove presenter"
              class="remove-btn flex items-center justify-center m-l-8 material-icons"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </app-chip>
      }

      <!-- Livestreams -->

      @for (livestream of queuedLivestreams() | keyvalue; track livestream) {
        <div class="presenter-container m-b-8" style="height: 120px">
          <div class="flex justify-between items-center m-b-12 flex-1">
            <span class="text-overflow-ellipsis flex-1">{{ getLivestreamTitle(livestream.value) }}</span>
            <a
              matRipple
              class="remove-btn flex items-center justify-center m-l-8"
              (click)="removeLivestream(livestream.key)"
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.199219 9.0706L0.927785 9.80019L4.99922 5.72923L9.07065 9.80019L9.79922 9.0706L5.72834 5.00019L9.79922 0.929786L9.07065 0.200195L4.99922 4.27116L0.927785 0.200195L0.199219 0.929786L4.2701 5.00019L0.199219 9.0706Z"
                  fill="#B00020"
                />
              </svg>
            </a>
          </div>
          <div class="flex justify-between items-center m-b-12 flex-1">
            <mat-slide-toggle
              data-testid="start-broadcast-toggle"
              [disabled]="isPresentationFull() || isLivestreamActive()"
              (toggleChange)="startBroadcast(livestream.value)"
              [checked]="isLivestreamBroadcasting(livestream.key)"
            >
              Broadcasting
            </mat-slide-toggle>
          </div>
          <div class="flex justify-center items-center uppercase">
            <a
              id="previewLivestream"
              data-testid="preview-livestream"
              class="action-item alignt-center"
              color="primary"
              matRipple
              (click)="previewLivestream(livestream.value)"
            >
              Preview
            </a>
          </div>
        </div>
      }
    </div>
  </div>
</div>
